import autobind from 'autobind-decorator';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Button, Icon, notification, Select, Spin, Modal, Alert } from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {Link, RouteComponentProps, withRouter} from 'react-router-dom';
import {ProjectMembersStore, ProjectMemberSummary} from 'src/stores/projectmembers-store';
import {ItemState, Query} from 'src/core/stores/dataStore';
import {TableModel, TableView} from 'src/core/ui/collections/table';
import {formatMessage} from 'src/core/services/http.service';
import {CommandResult} from 'src/core/stores/types';
import EditableTooltip from 'src/components/editable-tooltip/tooltip';
import {CacheProps, withCache} from 'src/core/services/cache.service';
import {withIdentity} from '../../../../core/services/authentication';
import { UserProfileProps, withUserProfile } from "../../../../components/user-profile";
import { ProjectSummary } from 'src/stores/projects-store';
import { dropdownRender } from '../../../../core/ui/form/select-sign'


const { Option } = Select;

// tslint:disable-next-line:no-empty-interface
interface EmployeeProjectsViewProps extends RouteComponentProps<{ companyId: string, employeeId: string }>, WithTranslation, CacheProps, UserProfileProps {
    employeeEmail: string | undefined;
    onRefreshRequired?: () => void;
}

interface EmployeeProjectsViewState {
    query: Query;
    newEmployeeProjectShown: boolean;
    projectsToAdd: string[];
    projectSearch: string;
    projects: ProjectSummary[];
    projectsLoading: boolean;
    projectsTotal: number
}

@connect(['projectMembers', ProjectMembersStore])
class EmployeeProjectsDashboard extends React.Component<EmployeeProjectsViewProps, EmployeeProjectsViewState> {

    private get projectMembersStore() {
        return (this.props as any).projectMembers as ProjectMembersStore;
    }

    constructor(props: EmployeeProjectsViewProps) {
        super(props);

        var queryStored = props.cache.getWithCustomKey("Employee-Projects")

        var query = { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: true }], skip: 0, take: 10 }

        if (queryStored)
            query = queryStored
        this.state = {
            query: query as any,
            newEmployeeProjectShown: false,
            projectsToAdd: [],
            projectSearch: '',
            projects: [],
            projectsLoading: false,
            projectsTotal:0
        };
    }

    componentWillMount() {
        this.projectMembersStore.changeUrlByEmployeeAndCompany(this.props.match.params.employeeId, this.props.match.params.companyId);
        this.load(this.state.query);
    }


    @autobind
    private load(query: Query) {
        this.props.cache.saveWithCustomKey("Employee-Projects", query);
        this.projectMembersStore.getAllAsync(query);
        this.loadProjects();
    }
  
    @autobind
    private async loadProjects(projectSearch : string = '') {
        this.setState({ projectsLoading: true });
        var query: Query = {
            searchQuery: projectSearch || '',
            skip: 0,
            take: 10,
            orderBy: [{ field: 'Title', direction: 'Ascending', useProfile: false }]
        };
        var currentProjects = await this.projectMembersStore.getProjects(query,this.props.match.params.companyId);
        const items = currentProjects.items as ProjectSummary[];
        this.setState({ projects: items });
        this.setState({ projectsTotal: currentProjects.count })
        this.setState({ projectsLoading: false });
        return items
    }
    

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }


    @autobind
    private async onDeleteRow(item: ProjectMemberSummary, state: ItemState): Promise<CommandResult<any>> {
        this.projectMembersStore.changeUrlByProject(this.props.match.params.companyId, item.projectId)
        var del = await this.projectMembersStore.deleteAsync(`${item.id}`)
        this.projectMembersStore.changeUrlByEmployeeAndCompany(this.props.match.params.employeeId, this.props.match.params.companyId);
        if (this.props.onRefreshRequired) {
            this.props.onRefreshRequired()
        }
        return del;
    }

    @autobind
    private onNewItem() {
        this.setState({ newEmployeeProjectShown: true });
    }

    @autobind
    private onNewEmployeeProjectClosed() {
        this.setState({ newEmployeeProjectShown: false});
    }

    @autobind
    private handleDropdownVisibleChange(open: boolean) {
        if (open && this.state.projects.length === 0) {
            this.setState({ projectSearch :''});
        }
    }
    @autobind
    private async onAssignProjects() {
        const { t } = this.props as any;
        await this.projectMembersStore.assignProjects(this.props.match.params.companyId, this.props.match.params.employeeId, this.state.projectsToAdd)
        .then((result) => {
            this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes");
        })
        .catch(error => {
                this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error");
        });
        this.setState({ newEmployeeProjectShown: false });
        this.load(this.state.query);
        this.setState({ projectsToAdd: [] });
    }

    
    public render() {
        const { t } = this.props as any;
        let isReadOnly = this.isReadOnly()
        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'title',
                    title: t('Projects'),
                    renderer: (data) =>
                        <span>
                            <span>{data.projectTitle}</span>
                        </span>,
                },
                {
                    sortable: true,
                    field: 'permission',
                    title: t('Permissions'),
                    renderer: (data) => <span>
                        {data.permission == 0 && <span>{t("None")}</span>}
                        {data.permission == 1 && <span>{t("Reader")}</span>}
                        {data.permission == 2 && <span>{t("Writer")}</span>}
                        {data.permission == 4 && <span>{t("Owner")}</span>}
                        {data.permission == 7 && <span>{t("Project Manager")}</span>}
                    </span>
                }
            ],
            data: this.projectMembersStore.state,
            sortFields: [{
                field: 'title',
                text: t('Projects'),
                useProfile: true
            },
                {
                    field: 'permission',
                    text: <EditableTooltip name='member-permission'> {t('Permissions')} </EditableTooltip>,
                    useProfile: true
                }],
        } as TableModel<ProjectMemberSummary>;


        return <Spin size='large' spinning={this.projectMembersStore.state.isBusy}>
            <TableView
                showDeleteStatusWindow
                rowKey='id'
                model={tableModel}
                error={this.projectMembersStore.state.result && !this.projectMembersStore.state.result.isSuccess && formatMessage(this.projectMembersStore.state.result)}
                embedded={false}
                onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                onRefresh={() => this.load(this.state.query)}
                canEdit={false}
                canDelete={!isReadOnly}
                onDeleteRow={this.onDeleteRow}
                canCreateNew={!isReadOnly}
                onNewItem={this.onNewItem}
                 />

            {this.state.newEmployeeProjectShown &&
                <Modal
                    maskClosable={false}
                    visible
                    onCancel={this.onNewEmployeeProjectClosed}
                    onOk={this.onAssignProjects}
                    closable={false}
                    width='800px'
                    okText={t("OK")}
                    cancelText={t("Cancel")}
                    title={t("Assign Projects")}>
                    {this.projectMembersStore.state.result && !this.projectMembersStore.state.result.isSuccess &&
                        <Alert type='error'
                        message={t("Error")}
                        description={formatMessage(this.projectMembersStore.state.result)}
                        />
                    }
                    <Select
                        mode="multiple"
                        style={{ width: '100%', borderColor: '#364966', marginTop: '4px' }}
                        placeholder={t('Projects ...')}
                        onChange={(value: any) => { this.setState({ projectsToAdd: value }) }}
                        filterOption={false}
                        value={this.state.projectsToAdd}
                        onSearch={(value: any) => { this.loadProjects(value); }}
                        dropdownRender={this.state.projectsTotal > this.state.projects.length ? (menu) => dropdownRender(menu, this.state.projectsTotal, this.state.projects.length) : undefined}
                        onDropdownVisibleChange={this.handleDropdownVisibleChange}
                        loading={this.state.projectsLoading}
                    >
                        {this.state.projects.map((project, index) => {
                            return <Option value={project.id}>{project.title}</Option>
                        })}

                    </Select>
                </Modal>
            } 
        </Spin>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withCache(withTranslation()(withIdentity(withRouter(EmployeeProjectsDashboard)))));
